<template>
  <div class="c-list-excerpt">
    An objective, consensus-driven security guideline for the
    <span>{{ excerpt() }}.</span>
  </div>
</template>

<script>
export default {
  name: 'CIS-Resource-PagedListing-BenchmarkExcerpt',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    excerpt() {
      return this.item?.category?.value?.length > 0
        ? `${this.item?.resourceTitle?.value} ${this.item?.category?.value}`
        : this.item?.resourceTitle?.value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/components/c-list-excerpt.scss';
</style>
